import { useQuery } from '@tanstack/react-query';
import {
  fetch_schedule_day,
  fetch_schedule_month,
  type ScheduleDayDetail,
  type ScheduleMonth,
} from './api';
import type { VendorModuleType } from '@/features/availability/types';

/**
 * Month cells are cached for a minute: paging back and forth through history should not refetch
 * a settled past month on every click, and a booking landing today is not urgent enough to
 * justify a request per keypress on the arrows.
 */
export function use_schedule_month(month: string, module_type: VendorModuleType | '') {
  return useQuery<ScheduleMonth>({
    queryKey: ['vendor-schedule', 'month', month, module_type],
    queryFn: () => fetch_schedule_month({ month, module_type }),
    staleTime: 60_000,
  });
}

/** The day panel is only fetched once a date is actually selected. */
export function use_schedule_day(date: string | null, module_type: VendorModuleType | '') {
  return useQuery<ScheduleDayDetail>({
    queryKey: ['vendor-schedule', 'day', date, module_type],
    queryFn: () => fetch_schedule_day({ date: date as string, module_type }),
    enabled: !!date,
    staleTime: 30_000,
  });
}
